import { FC, ReactNode } from 'react';

import { rem, StyleProps } from '@bonusly/design-system';

import { BonusCard } from '../bonus-card/bonus-card';
import { Carousel } from '../carousel/carousel';
import { FeedbackCard } from '../feedback-card/feedback-card';
import { References } from './types';

type LabelReferencesCarouselProps = {
	references: References[];
	unlinkConfirmTitle?: string;
	onUnlinkFeedback?: (feedbackId: string) => void;
	onUnlinkBonus?: (bonusId: string) => void;
	cardStyle?: StyleProps;
	children: ReactNode;
};

export const ReferencesCarousel: FC<LabelReferencesCarouselProps> = ({
	references,
	unlinkConfirmTitle,
	onUnlinkFeedback,
	onUnlinkBonus,
	cardStyle,
	children,
}) => {
	if (references.length == 0) {
		return null;
	}

	return (
		<Carousel increment={500}>
			{children}

			{references.map((reference) => {
				switch (reference.type) {
					case 'bonus':
						return (
							<BonusCard
								bonus={reference.item}
								key={reference.item.id}
								onUnlinkBonus={onUnlinkBonus}
								sectionTitle={unlinkConfirmTitle}
								width={{ base: rem(300), md: rem(410) }}
								border="1px solid"
								borderColor="border.default"
								marginBottom={4}
								marginX={{ base: 'auto', md: 0 }}
								bg="bg.surface"
								boxShadow="none"
								{...cardStyle}
							/>
						);
					case 'feedback':
						return (
							<FeedbackCard
								feedback={reference.item}
								key={reference.item.id}
								sectionTitle={unlinkConfirmTitle}
								onUnlinkFeedback={onUnlinkFeedback}
								width={{ base: rem(300), md: rem(410) }}
								{...cardStyle}
							/>
						);
					default:
						return null;
				}
			})}
		</Carousel>
	);
};
ReferencesCarousel.displayName = 'ReferencesCarousel';
